/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { backgroundColorPalette, backgroundColorPaletteNext } from '@atlaskit/adf-schema';
import Icon from '@atlaskit/icon';
import { useThemeObserver } from '@atlaskit/tokens';
import getColorMessage from './getColorMessage';
import paletteMessages from './paletteMessages';
import { mapPaletteColor } from './textColorPalette';
export var REMOVE_HIGHLIGHT_COLOR = '#00000000';
var DiagonalLineGlyph = function DiagonalLineGlyph() {
  return jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("rect", {
    width: "24",
    height: "24",
    fill: "white",
    fillOpacity: "0.01"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2038 7.70388C17.5955 8.09565 17.5941 8.73128 17.2005 9.12127L9.1213 17.1277C8.73027 17.5152 8.09958 17.5138 7.71031 17.1245C7.31854 16.7328 7.31997 16.0971 7.71351 15.7071L15.7928 7.70069C16.1838 7.31318 16.8145 7.31461 17.2038 7.70388Z",
    fill: "currentColor",
    fillOpacity: "0.5"
  }));
};
export var EditorDiagonalLineIcon = function EditorDiagonalLineIcon() {
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  var primaryColor = colorMode === 'dark' ? "var(--ds-background-accent-gray-bolder, #626F86)" : "var(--ds-background-accent-gray-subtle, #8590A2)";
  return jsx(Icon, {
    glyph: DiagonalLineGlyph,
    label: "",
    primaryColor: primaryColor
  });
};

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated Use `highlightColorPaletteNext` instead, which supports both orange and yellow highlight color
 * This will be removed when platform_editor_add_orange_highlight_color is cleaned up
 */
export var highlightColorPalette = [{
  value: REMOVE_HIGHLIGHT_COLOR,
  // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
  label: 'No color',
  // Mostly informative, only used for analytics
  border: "var(--ds-border, #091E4224)",
  message: getColorMessage(paletteMessages, 'no-color'),
  decorator: jsx(EditorDiagonalLineIcon, null)
}];
backgroundColorPalette.forEach(function (label, color) {
  highlightColorPalette.push(mapPaletteColor(label, color));
});
export var highlightColorPaletteNext = [{
  value: REMOVE_HIGHLIGHT_COLOR,
  // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
  label: 'No color',
  // Mostly informative, only used for analytics
  border: "var(--ds-border, #091E4224)",
  message: getColorMessage(paletteMessages, 'no-color'),
  decorator: jsx(EditorDiagonalLineIcon, null)
}];
backgroundColorPaletteNext.forEach(function (label, color) {
  highlightColorPaletteNext.push(mapPaletteColor(label, color));
});